import React from 'react'
import { Modal } from 'react-bootstrap'

export default class formInput extends React.Component {
    render() {
        const { changeHandler, saveHandler, Model, ShowModal, CreateHandler, EditHandler, CancelHandler,errors, Mode } = this.props

        return (
            <div>
                <Modal show={ShowModal} onHide={CancelHandler}>
                    <Modal.Header closeButton>
                        <Modal.Title>{Mode}</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <div class="mb-3">
                            <label for="NAMA" class="form-label">NAMA*</label>
                            <input type="txt" class="form-control" id="NAMA" value={Model.NAMA} onChange={changeHandler("NAMA")} />
                            <span class= "error">{errors["NAMA_1"]}</span>
                            <span class= "error">{errors["NAMA_2"]}</span>
                        </div>
                        
                    </Modal.Body>

                    <Modal.Footer>
                    <button type="button" class="btn btn-light" onClick={CancelHandler}>Batal</button>
                    <button type="button" class="btn btn-primary" onClick={saveHandler}>Simpan</button>
                    </Modal.Footer>
                </Modal>

            </div>
        )
    }
}